// src/App.js
import React, { Suspense, lazy } from 'react';
import './styles/index.css';

import { LangProvider } from './context/LangContext';

// ── Always-visible shell components (no lazy) ────────────────────
import Navbar        from './components/Navbar';
import Footer        from './components/Footer';
import WhatsAppFloat from './components/WhatsAppFloat';
import LoadingScreen from './components/LoadingScreen';
import ScrollProgress from './components/ScrollProgress';
import BackToTop     from './components/BackToTop';

// ── Sections: lazy-loaded for faster initial bundle ───────────────
const Hero         = lazy(() => import('./sections/Hero'));
const Portfolio    = lazy(() => import('./sections/Portfolio'));
const WhyLawaseq   = lazy(() => import('./sections/WhyLawaseq'));
const Services     = lazy(() => import('./sections/Services'));
const Industries   = lazy(() => import('./sections/Industries'));
const Testimonials = lazy(() => import('./sections/Testimonials'));
const FAQ          = lazy(() => import('./sections/FAQ'));
const Contact      = lazy(() => import('./sections/Contact'));
const Jobs         = lazy(() => import('./sections/Jobs'));

// Minimal fallback shown while a lazy section loads
const SectionFallback = () => (
  <div style={{ minHeight: '400px', background: 'var(--dark-2)' }} aria-hidden />
);

function App() {
  return (
    <LangProvider>
      <LoadingScreen />
      <ScrollProgress />

      <div
        className="App"
        style={{
          backgroundColor: '#1A1A1A',
          color          : '#ffffff',
          minHeight      : '100vh',
          overflowX      : 'hidden',
        }}
      >
        <Navbar />

        <main>
          <Suspense fallback={<SectionFallback />}>
            <Hero />
            <Portfolio />
            <WhyLawaseq />
            <Services />
            <Industries />
            <Testimonials />
            <FAQ />
            <Contact />
            <Jobs />
          </Suspense>
        </main>

        <Footer />
        <WhatsAppFloat />
        <BackToTop />
      </div>
    </LangProvider>
  );
}

export default App;